import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Work from './pages/Work';
import MusicAndHobbies from './pages/MusicAndHobbies';
import Contact from './pages/Contact';
import Bible from './pages/Bible';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<Work />} />
            <Route path="/music-and-hobbies" element={<MusicAndHobbies />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/bible" element={<Bible />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 